import { Link } from "react-router-dom";

const icons = [
  { name: "Plates", img: "https://cdn-icons-png.flaticon.com/512/1046/1046784.png" },
  { name: "Hot Meals", img: "https://cdn-icons-png.flaticon.com/512/1046/1046751.png" },
  { name: "Cupcakes", img: "https://cdn-icons-png.flaticon.com/512/685/685352.png" },
  { name: "Cakes", img: "https://cdn-icons-png.flaticon.com/512/3081/3081967.png" },
  { name: "Pets", img: "https://cdn-icons-png.flaticon.com/512/616/616408.png" },
  { name: "Drinks", img: "https://cdn-icons-png.flaticon.com/512/2738/2738730.png" },
  { name: "Bread", img: "https://cdn-icons-png.flaticon.com/512/1046/1046786.png" }
];

const IconSlider = () => {
  return (
    <section className="py-12 bg-[#fff9e6]">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Centered Row */}
        <div className="flex justify-between items-center max-w-5xl mx-auto">
          {icons.map((item, index) => (
            <Link
              key={index}
              to="/recipes"
              className="flex flex-col items-center hover:scale-105 transition"
            >
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-white shadow-md">
                <img
                  src={item.img}
                  alt={item.name}
                  className="w-12 h-12 object-contain"
                />
              </div>
              <span className="mt-2 text-sm font-medium text-gray-700">
                {item.name}
              </span>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};

export default IconSlider;
